module.exports = __webpack_public_path__ + "static/media/map.7cde4f12.png";